const list=value=>{try{const result=JSON.parse(value||'[]');return Array.isArray(result)?result:[]}catch{return []}};
export function folderMuted(prefs,viewerId,communityId){
 if(!communityId)return false;
 let layout;try{layout=JSON.parse(prefs['malvo-server-layout:'+viewerId]||'{}')}catch{return false}
 const muted=new Set(list(prefs['malvo-muted-folders']));
 return (Array.isArray(layout.folders)?layout.folders:[]).some(f=>muted.has(f.id)&&Array.isArray(f.members)&&f.members.includes(communityId));
}
export function messageNotificationAllowed(prefs,viewerId,{communityId,roomId,mentioned=false}={}){
 if(folderMuted(prefs,viewerId,communityId))return false;
 return mentioned||!(list(prefs['malvo-muted-servers']).includes(communityId)||list(prefs['malvo-muted-channels']).includes(roomId));
}
